import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { Bell, CheckCircle2 } from "lucide-react";

export default function Notifications() {
  const [notifs, setNotifs] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setNotifs(r.data)).catch(() => {}); }, []);
  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setNotifs((ns) => ns.map((n) => n.id === id ? { ...n, read: true } : n));
  };
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Notifications</div>
          <h1 className="font-display text-3xl mt-2">What's new for you</h1>
        </div>
        <div className="space-y-3">
          {notifs.map((n) => (
            <Card key={n.id} className={`p-5 flex items-start gap-4 ${!n.read ? "border-primary/30 bg-primary/5" : ""}`}>
              <div className="h-10 w-10 rounded-lg brand-gradient text-white flex items-center justify-center"><Bell className="h-4 w-4" /></div>
              <div className="flex-1">
                <div className="font-medium">{n.title}</div>
                <div className="text-sm text-muted-foreground">{n.body}</div>
                <div className="text-xs text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString()}</div>
              </div>
              {!n.read && <button onClick={() => markRead(n.id)} className="text-xs text-primary flex items-center gap-1" data-testid={`notif-read-${n.id}`}><CheckCircle2 className="h-3 w-3" /> Mark read</button>}
            </Card>
          ))}
          {notifs.length === 0 && <Card className="p-8 text-sm text-muted-foreground">No notifications yet.</Card>}
        </div>
      </div>
    </DashboardLayout>
  );
}
